import { CSSProperties } from 'react';

interface AvatarProps {
  initials: string;
  color?: string;
  bg?: string;
  border?: string;
  imageUrl?: string | null;
  size?: number;
  /** 'circle' for users, 'rounded' (rounded-square) for brand marks. */
  shape?: 'circle' | 'rounded';
  title?: string;
  onClick?: () => void;
  imageObjectFit?: 'cover' | 'contain';
}

export const Avatar = ({
  initials,
  color,
  bg,
  border,
  imageUrl,
  size = 24,
  shape = 'circle',
  title,
  onClick,
  imageObjectFit = 'cover',
}: AvatarProps) => {
  const radius =
    shape === 'rounded' ? Math.max(4, Math.round(size * 0.18)) : size / 2;
  const style: CSSProperties = {
    width: size,
    height: size,
    fontSize: size * 0.44,
    color: color ?? 'var(--ink-2)',
    background: bg ?? 'var(--bg-active)',
    borderRadius: radius,
    ...(border ? { border, boxSizing: 'border-box' } : null),
  };

  if (imageUrl) {
    // Logo fills the avatar bounds — `cover` avoids the white-space ring
    // that 'contain' + padding produced. Rounded corners are preserved by
    // the parent's border-radius + overflow:hidden.
    return (
      <div
        className="avatar"
        style={{ ...style, padding: 0, overflow: 'hidden' }}
        title={title}
        onClick={onClick}
      >
        <img
          src={imageUrl}
          alt={initials}
          style={{ width: '100%', height: '100%', objectFit: imageObjectFit }}
        />
      </div>
    );
  }

  return (
    <div className="avatar" style={style} title={title} onClick={onClick}>
      {initials}
    </div>
  );
};

export default Avatar;
